
export class MovePlanogramsRequest {
  parentFolderId: string;
  planograms: string[];
  constructor(parentFolderId: string, planograms: string[]) {
    this.parentFolderId = parentFolderId;
    this.planograms = planograms;
  }
}
